//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { openLightbox } from '../../../redux/actions/lightboxStateActions';

import TerrainInfoEditor from '../Editors/TerrainInfo';
import TerrainInfoViewer from '../Viewers/TerrainInfo';

type props = {
  terrain_information: Object,
  quick_facts: Object,
  elevation_profile: string,
  isActiveEditor: string,
  openLightbox: Function,
};

class TerrainInfo extends Component<props> {
  static defaultProps = {
    terrain_information: {},
    quick_facts: {},
    elevation_profile: null,
  };

  render() {
    const {
      terrain_information,
      quick_facts,
      elevation_profile,
      isActiveEditor,
      openLightbox,
    } = this.props;
    return isActiveEditor ? (
      <TerrainInfoEditor />
    ) : (
      <TerrainInfoViewer
        terrain_information={terrain_information}
        quick_facts={quick_facts}
        elevation_profile={elevation_profile}
        openLightbox={openLightbox}
      />
    );
  }
}

const mapStateToProps = ({ trekOverview }) => ({
  isActiveEditor: trekOverview.activeEditor === 'TerrainInfoEditor',
});

export default connect(
  mapStateToProps,
  { openLightbox }
)(TerrainInfo);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/TerrainInfo.jsx